import React, { memo } from 'react';
import { Spin, Empty } from 'antd';
import { useQueryClient } from 'react-query';
import FacilityAndRoomsMeters from './FacilityAndRoomsMeters/FacilityAndRoomsMeters';
import useMeters from '../../queries/useMeters';
import useSetRefreshFn from '../../../../hooks/useSetRefreshFn';
import queries from '../../queries/queries';
import styles from './Meters.module.scss';

const Meters = () => {
  const queryClient = useQueryClient();

  const { data: facilitiesWithMeters, isFetching } = useMeters();

  useSetRefreshFn(() => {
    queryClient.invalidateQueries([queries.meters])
  }, [])

  return (
    <Spin spinning={isFetching}>
      <div className={styles.metersLayout}>
        {facilitiesWithMeters.length ? (
          facilitiesWithMeters?.map((facilityWithMeters) => (
            <FacilityAndRoomsMeters
              key={facilityWithMeters.id}
              facilityWithMeters={facilityWithMeters}
            />
          ))
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    </Spin>
  );
};

export default memo(Meters);
